import { useParams } from 'react-router-dom'

interface Params {
  placeId: string
  id?: string
}

const usePlaceMapParams = () => {
  return useParams<Params>()
}

export default usePlaceMapParams